import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../../../core/Icon';
import EcrionLogo from '../../../../core/Icon/Logo';
import Link from '../../../../formatter/Link';
import NavBarUser from './User';
import NavBarSearch from './Search';
import NavBarModules from './Modules';

var styles = function styles(theme) {
  return createStyles({
    navbar: {
      paddingLeft: 0,
      paddingRight: 0,
      fontSize: theme.typography.fontSize,
      width: '100%',
      height: theme.common.Page.NavBar.style.height,
      minHeight: theme.common.Page.NavBar.style.height,
      backgroundColor: theme.common.Page.NavBar.style.backgroundColor,
      color: theme.palette.getContrastText(theme.common.Page.NavBar.style.backgroundColor),
      '& a': {
        textDecoration: 'none'
      }
    },
    centerArea: _defineProperty({
      height: '100%',
      textAlign: 'center',
      opacity: 0.85
    }, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    centerAreaContent: {
      lineHeight: theme.common.Page.NavBar.style.height + 'px'
    },
    rightArea: {
      height: '100%'
    },
    menuButton: {
      width: 42,
      color: theme.palette.getContrastText(theme.common.Page.NavBar.style.backgroundColor)
    },
    menuIcon: {
      fontSize: 22
    },
    logoButton: {
      height: theme.common.Page.NavBar.style.height,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      opacity: 0.85,
      '&:hover': {
        opacity: 1,
        cursor: 'pointer'
      }
    },
    logoText: {
      marginLeft: theme.spacing(1)
    },
    taskIcon: {
      color: theme.palette.getContrastText(theme.common.Page.NavBar.style.backgroundColor),
      height: theme.common.Page.NavBar.style.height,
      display: 'block',
      padding: theme.spacing(2),
      paddingTop: theme.spacing(2) + 2,
      '&:hover, &:focus': {
        color: theme.palette.getContrastText(darken(theme.common.Page.NavBar.style.backgroundColor, 0.2)),
        backgroundColor: darken(theme.common.Page.NavBar.style.backgroundColor, 0.2)
      }
    },
    xsHide: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'none'
    })
  });
};

var DefaultLogoComponent = function DefaultLogoComponent(props) {
  return React.createElement("a", Object.assign({
    href: "/"
  }, props));
};
/**
 * @extends {React.Component<Props>}
 */


var DefaultNavBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DefaultNavBar, _React$Component);

  function DefaultNavBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefaultNavBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefaultNavBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.toggleAppBar = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    };

    return _this;
  }

  _createClass(DefaultNavBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme,
          userInfo = _this$props.userInfo,
          manifest = _this$props.manifest,
          hideMenu = _this$props.hideMenu,
          showSearch = _this$props.showSearch,
          showTasks = _this$props.showTasks,
          searchInputProps = _this$props.searchInputProps,
          logoComponent = _this$props.logoComponent,
          logoProps = _this$props.logoProps; //wait for the manifest

      if (!manifest.Name) return null;
      var accent = manifest.Color || theme.common.Page.NavBar.style.backgroundColor;
      var style = {
        backgroundColor: accent,
        color: theme.palette.getContrastText(accent)
      };
      var LogoComponent = logoComponent || DefaultLogoComponent;
      var logoChildren = React.createElement(Grid, {
        container: true,
        alignItems: "center",
        className: classes.logoButton,
        style: {
          color: style.color
        }
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(EcrionLogo, {
        src: manifest.IconURL,
        alt: manifest.Name
      })), React.createElement(Grid, {
        item: true,
        className: classes.logoText
      }, React.createElement(Typography, {
        color: "inherit"
      }, manifest.Name)));

      var logoComponentProps = _objectSpread({
        children: logoChildren
      }, logoProps);

      return React.createElement(React.Fragment, null, React.createElement(Toolbar, {
        className: classes.navbar,
        style: style
      }, React.createElement(Grid, {
        container: true,
        alignContent: "space-between",
        alignItems: "stretch"
      }, React.createElement(Grid, {
        item: true,
        sm: true
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center",
        alignContent: "stretch"
      }, !hideMenu && React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, {
        type: "menu",
        "aria-label": "Menu",
        buttonProps: {
          className: classes.menuButton
        },
        className: classes.menuIcon,
        onClick: this.toggleAppBar
      })), React.createElement(Grid, {
        item: true,
        className: classes.xsHide
      }, React.createElement(LogoComponent, logoComponentProps)))), React.createElement(Grid, {
        item: true,
        className: classes.centerArea
      }, React.createElement(Typography, {
        color: "inherit",
        component: "span",
        className: classes.centerAreaContent
      }, React.createElement("span", null, userInfo.environmentName))), React.createElement(Grid, {
        item: true,
        xs: true
      }, React.createElement(Grid, {
        container: true,
        alignItems: "stretch",
        alignContent: "flex-end",
        justify: "flex-end",
        className: classes.rightArea
      }, showSearch && React.createElement(Grid, {
        item: true
      }, React.createElement(NavBarSearch, searchInputProps)), showTasks && React.createElement(Grid, {
        item: true,
        className: classes.xsHide
      }, React.createElement(Link, {
        openInNewTab: true,
        value: "/EOS/Task/#task/Tasks",
        icon: {
          type: 'tasks'
        },
        className: classes.taskIcon
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(NavBarUser, {
        userInfo: userInfo
      })))))), React.createElement(NavBarModules, {
        open: this.state.open,
        toggle: this.toggleAppBar
      }));
    }
  }]);

  return DefaultNavBar;
}(React.Component);
/**
 * @typedef {object} Props
 * @property {boolean} [hideMenu] Whether to hide the expandable menu or not
 * @property {boolean} [showSearch] Whether to show a search control or not
 * @property {boolean} [showTasks] Whether to show a the tasks button
 * @property {object} [searchInputProps] Additional props to pass to the search input
 * @property {import("react").ComponentType} [logoComponent] The component used for the logo node. Either a string to use a DOM element or a component. By default, it's an anchor which navigates to the location root.
 * @property {object} [logoProps] Properties applied to the `logoComponent`.
 *
 * @property {object} [manifest] Injected by HoC
 * @property {object} [userInfo] Injected by HoC
 * @property {object} [classes] Injected by HoC
 * @property {object} [theme] Injected by HoC
 */


DefaultNavBar.defaultProps = {
  hideMenu: false,
  showSearch: false,
  showTasks: false,
  searchInputProps: {},
  logoProps: {}
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECDefaultNavBar'
})(DefaultNavBar);